import { Construction } from 'lucide-react'

/**
 * Stands in for a module that is routed but not yet built.
 *
 * Routing every module from the start means the sidebar, the command palette
 * and the `g`-shortcuts are all exercised for real from day one, rather than
 * being wired up blind at the end.
 */
export function ModulePlaceholder({ title, note }: { title: string; note?: string | undefined }) {
  return (
    <div className="flex min-h-[60vh] items-center justify-center px-6">
      <div className="max-w-md text-center">
        <Construction className="mx-auto size-8 text-fg-subtle" aria-hidden />
        <h2 className="mt-4 text-lg font-semibold text-fg">{title}</h2>
        <p className="mt-2 text-sm text-fg-secondary">
          {note ?? 'This module is not built yet.'}
        </p>
      </div>
    </div>
  )
}

/** Builds a routable element for a module that has no screen yet. */
export function placeholderFor(title: string, note?: string) {
  return <ModulePlaceholder title={title} {...(note !== undefined ? { note } : {})} />
}
